import { ref } from 'vue';

export const sharedState = {
  activeRemarkInput: ref<number | null>(null),
};
